export const NO_VALUE_LABEL = 'No value';
export const NO_OPTION_VALUE_SUFFIX = '__ev_no_option__';

export const UNIT_ID_NO_OPTION_VALUE = `Unitid: ${NO_OPTION_VALUE_SUFFIX}`;

export const BUSINESS_UNIT_NORMALIZED_KEY = 'unitid';
export const UNIT_ID_FILTER_KEY = 'unitId';

export const ENVIRONMENT_NO_OPTION_VALUE = `Environment: ${NO_OPTION_VALUE_SUFFIX}`;

export const ENVIRONMENT_NORMALIZED_KEY = 'environment';
export const ENVIRONMENT_FILTER_KEY = 'environment';
